import AboutPage from '../../components/pages/statics/AboutPage'
export default {
  components: { AboutPage }
}
